import ErrorDisplay from "../errorDisplay";

import './style.scss';

let idx = 0;

const FormRadio = (props) => {
  const {
    name,
    id,
    label,
    value,
    options,
    changeAction,
    onKeyDown,
    errors,
    disabled,
    hide,
    focusOnError
  } = props;

  const idValue = id || label || name;
  const hasError = Boolean(errors?.length);
  const errorId = 'error-' + idx++;

  return (
    <div className={(hide) ? 'sr-hide' : 'form-radio'}>
      <label htmlFor={idValue}>{label || name || id}</label>
      {options.map((option,idx) => {
        return (<>
            <input
              type="radio"
              id={`${name}-${idx}`}
              className={hasError ? 'error input-radio' : 'input-radio'}
              name={name}
              value={option.value}
              checked={option.value === value}
              disabled = {disabled}
              onChange={(e) => changeAction(e.target.value)}
            />
            <label className='input-radio-label' htmlFor={`${name}-${idx}`}>{option.label}</label>
          </>
        )})}
      { hasError && <ErrorDisplay shouldFocus={focusOnError} errors={errors} id={errorId}/> }
    </div>
  )
};

export default FormRadio;
